module.exports = __webpack_public_path__ + "line.567f57385ea3dde2c9ae.gif";


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/~/primeng/resources/images/line.gif
// module id = ../../../../primeng/resources/images/line.gif
// module chunks = 1